<app-admin-page-shell
  titleKey="app.admin.settings.title"
  subtitleKey="app.admin.settings.subtitle"
  [panelled]="false"
>
  <section class="settings-flags" aria-labelledby="settings-flags-heading">
    <div class="settings-flags__header">
      <h2 id="settings-flags-heading" class="settings-flags__title">
        {{ 'app.admin.settings.flagsTitle' | translate }}
      </h2>
      <p class="settings-flags__hint">
        {{ 'app.admin.settings.flagsHint' | translate }}
      </p>
    </div>

    @if (isLoading()) {
      <div class="settings-flags__loading">
        <mat-spinner diameter="36"></mat-spinner>
        <p>{{ 'app.admin.settings.loading' | translate }}</p>
      </div>
    } @else if (hasError()) {
      <div class="settings-flags__error">
        <p>{{ 'app.admin.settings.error' | translate }}</p>
        <app-cta-button size="small" (clicked)="loadFlags()">
          <span cta-label>{{ 'app.admin.settings.retry' | translate }}</span>
        </app-cta-button>
      </div>
    } @else {
      <ul class="settings-flags__list">
        @for (flag of flags(); track flag.key) {
          <li class="settings-flag">
            <div class="settings-flag__copy">
              <code class="settings-flag__key">{{ flag.key }}</code>
              @if (flag.description) {
                <p class="settings-flag__description">{{ flag.description }}</p>
              }
            </div>
            <app-admin-toggle-switch
              [checked]="flag.enabled"
              [disabled]="toggleBusyKey() === flag.key"
              [ariaLabel]="flag.key"
              (checkedChange)="toggleFlag(flag, $event)"
            />
          </li>
        }
      </ul>
    }
  </section>
</app-admin-page-shell>
